import { createSelector } from 'reselect';
import { RootState } from '../store';
import { selectIsDemoMode, selectDemoTransactions } from './demo';

// Base transactions selector
const selectBaseTransactions = (state: RootState) =>
  state.transactions.transactions;

// Enhanced selector that includes demo data when in demo mode
// Sorts transactions by listing createdAt descending (most recent first)
export const selectTransactions = createSelector(
  [selectBaseTransactions, selectIsDemoMode, selectDemoTransactions],
  (baseTransactions, isDemoMode, demoTransactions) => {
    const transactions = isDemoMode
      ? [...demoTransactions, ...baseTransactions]
      : baseTransactions;

    return [...transactions].sort(
      (a, b) =>
        new Date(b.listings.createdAt).getTime() -
        new Date(a.listings.createdAt).getTime()
    );
  }
);

export const selectTransactionById = (state: RootState, id: string) => {
  const transactions = selectTransactions(state);
  return transactions.find((transaction) => transaction.id === id);
};

export const selectTransactionByListingId = (state: RootState, id: string) => {
  const transactions = selectTransactions(state);
  return transactions.find((transaction) => transaction.listingId === id);
};
